// Если уже соглашались с использованием куков,
// больше не показываем попап

(function ($) {
    const $popup = $('.js-popup-cookie');

    if ($.cookie('agree_use_cookie')) {
        $popup.addClass('_hidden');
    }

    $('.js-cookie-agree').on('click', function() {
        $popup.addClass('_hidden');
        $.cookie('agree_use_cookie', '1', {path: '/'});
    });
})(jQuery);



// WEBPACK FOOTER //
// ./_src/js/popup-cookie.js